export type BookAccount = 'available' | 'receivable' | 'contested' | 'reserved'

export const bookAccounts: BookAccount[] = ['available', 'receivable', 'contested', 'reserved']
